import { HiEnvelope } from "react-icons/hi2";

export const MailIcon = ({ width, height, ...props }) => (
  <HiEnvelope size={width || height || 22} {...props} />
);
